/**
 * Convert input label to input name prop
 * @function getNameFromLabel
 * @param {string} label
 * @returns {string}
 */
export const getNameFromLabel = (label = ""): string => {
	let name = "";
	const chars = label?.split("");

	for (let i = 0, l = label.length; i < l; i++) {
		if (chars[i] === " ") name += "-";
		else name += (chars[i] as string).toLowerCase();
	}

	return name;
};
